import axios from "axios";
import { getBaseUrl } from "./urls";
import { toast } from "react-toastify";
export const FETCH_CC_META_DATA = "FETCH_CC_META_DATA";
export const FETCH_CC_META_DATA_ON_VIEW_CHANGE = "FETCH_CC_META_DATA_ON_VIEW_CHANGE";
export const FETCH_FILTER_DATA = "FETCH_FILTER_DATA";
export const TOGGLE_GLOBAL_LOADER = "TOGGLE_GLOBAL_LOADER";
export const TOGGLE_EDIT_MODE = "TOGGLE_EDIT_MODE";
export const WIDGET_LOADED = "WIDGET_LOADED";
export const SET_WIDGET_LOADERS = "SET_WIDGET_LOADERS";
export const RESET_TO_DEFAULT_DISABLED = "RESET_TO_DEFAULT_DISABLED";
export const RESET_TO_DEFAULT_ENABLED = "RESET_TO_DEFAULT_ENABLED";
export const POST_MODAL_OPEN = "POST_MODAL_OPEN ";
export const POST_MODAL_CLOSED = "POST_MODAL_CLOSED";
export const ENABLE_GLOBAL_REFRESH = "ENABLE_GLOBAL_REFRESH";
export const ENABLE_GLOBAL_REFRESH_WITH_DEEP_DIVE = "ENABLE_GLOBAL_REFRESH_WITH_DEEP_DIVE";
export const HANDLE_GLOBAL_COUNTRY = "HANDLE_GLOBAL_COUNTRY";
export const RESET_GLOBAL_COUNTRY = "RESET_GLOBAL_COUNTRY";
export const FETCH_COLLECTIONS_LIST = "FETCH_COLLECTIONS_LIST";
export const TRANSLATED = "TRANSLATED";
export const SAVE_GLOBAL_FILTER = "SAVE_GLOBAL_FILTER";
export const RESET_GLOBAL_FILTER = "RESET_GLOBAL_FILTER";
export const SET_LAST_LANGUAGE = "SET_LAST_LANGUAGE";

const formatThemes = themes => {
    let optns = [], allThemes = [], treeThemes = {}
    if(themes.brand)
    Object.keys(themes.brand).map(theme => {
        treeThemes[theme] = []
        // const topics = themes.brand[theme] && themes.brand[theme][0].theme_customization ? JSON.parse(themes.brand[theme][0].theme_customization).topics : [];
        let topics = {};
        let optionHeading = {
            key: theme,
            value: `themeHeading-${theme}`,
            text: theme,
            content: theme,
            themeType: "theme",
            view: "brand",
            // topics,
        };
        let suboptions = []
        themes.brand[theme].map(subthemes => {
            allThemes.push(subthemes.subtopic_id)
            treeThemes[theme].push(subthemes.subtopic_id)
            const subThemeTopics = subthemes.theme_customization ? JSON.parse(subthemes.theme_customization).topics : {};
            topics = {...topics, ...subThemeTopics}
            suboptions.push({
                key: subthemes.subtopic_id,
                value: subthemes.subtopic_id,
                text: subthemes.subtopic_name,
                themeType: "subtheme",
                view: "brand",
                theme_name: theme,
                topics: subThemeTopics,
            });
        })
        optionHeading.topics = topics
        optns.push(optionHeading)
        optns.push(...suboptions)
    });
    if(themes.campaign)
    Object.keys(themes.campaign).map(theme => {
        treeThemes[theme] = []
        // const topics = themes.campaign[theme] && themes.campaign[theme][0].theme_customization ? JSON.parse(themes.campaign[theme][0].theme_customization).topics : [];
        let topics = {};
        let optionHeading = {
            key: theme,
            value: `themeHeading-${theme}`,
            text: theme,
            content: theme,
            themeType: "theme",
            view: "campaign",
            // topics,
        };
        let suboptions = []
        themes.campaign[theme].map(subthemes => {
            allThemes.push(subthemes.subtopic_id)
            treeThemes[theme].push(subthemes.subtopic_id)
            const subThemeTopics = subthemes.theme_customization ? JSON.parse(subthemes.theme_customization).topics : {};
            topics = {...topics, ...subThemeTopics}
            suboptions.push({
                key: subthemes.subtopic_id,
                value: subthemes.subtopic_id,
                text: subthemes.subtopic_name,
                themeType: "subtheme",
                view: "campaign",
                theme_name: theme,
                topics: subThemeTopics,
            });
        })
        optionHeading.topics = topics
        optns.push(optionHeading)
        optns.push(...suboptions)
    });
    if(themes.GE)
    Object.keys(themes.GE).map(theme => {
        treeThemes[theme] = []
        const topics = themes.GE[theme] && themes.GE[theme][0].theme_customization ? JSON.parse(themes.campaign[theme][0].theme_customization).topics : [];
        optns.push({
            key: theme,
            value: `themeHeading-${theme}`,
            text: theme,
            content: theme,
            themeType: "theme",
            view: "campaign",
            topics,
        });
        themes.GE[theme].map(subthemes => {
            allThemes.push(subthemes.subtopic_id)
            treeThemes[theme].push(subthemes.subtopic_id)
            optns.push({
                key: subthemes.subtopic_id,
                value: subthemes.subtopic_id,
                text: subthemes.subtopic_name,
                themeType: "subtheme",
                view: "campaign",
                theme_name: theme,
                topics,
            });
        })
    });
    return {optns, allThemes, treeThemes}
}

export const fetchFilterData = (filters) => {
    let token = localStorage.getItem("token");
    if(filters.indexOf("countries")<0) filters+=",countries"
    if(filters.indexOf("platforms")<0) filters+=",platforms"
    if(filters.indexOf("influencers")<0) filters+=",influencers"

    let req = axios
        .get(`${getBaseUrl()}/meta?access-token=${token}&values=company,${filters}`)
        .then(response => {
            sessionStorage.setItem("view","view1")
            let res = { ...response.data };
            if(response.data.company.company_identifier==='sk2pg' || response.data.company.company_identifier==='generalelections'){
                const {optns, allThemes, treeThemes} = formatThemes(response.data.themes)
                res = { ...response.data, themes: optns, allThemes, treeThemes };
            }
            if(response.data.company.company_identifier==='mcisingapore'){
                const countries = response.data.countries.filter(c=>c.name==="Singapore")
                res.countries = countries;
            }
            localStorage.setItem("meta", JSON.stringify(res));
            return res;
        })
        .catch(err => {
            console.log(err);
        });

    return {
        type: FETCH_FILTER_DATA,
        payload: req
    };
};

export const fetchCCMetaData = (viewType) => {
    let token = localStorage.getItem("token");
    let req = axios.get(`${getBaseUrl()}/cc?access-token=${token}&view_type=${viewType}`).then(response => {
        return response.data.data.command_center;
    }).catch(error => {
        console.log(error);
        toast.error('Oops! We encountered an error. Please refresh the page and retry logging in.')
        setTimeout(() => {window.location.href = window.location.href.replace('/home', '/')}, 4000)

    });

    return {
        type: FETCH_CC_META_DATA,
        payload: req
    };
};

export const signOutAuth = (access_token) => {
    let url = `https://api2.radarr.com/auth-service/logout`;
    // const url=getUrl('sign_in');
    let data = { access_token };
    let req = axios({
        method: "post",
        url,
        data,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            return err;
        });

    return {
        type: "SIGN_OUT",
        payload: req,
    };
};

export const fetchCCMetaDataOnViewChange = (viewType) => {
    let token = localStorage.getItem("token");
    let req = axios.get(`${getBaseUrl()}/cc?access-token=${token}&view_type=${viewType}`).then(response => {
        return response.data.data.command_center;
    }).catch(error => {
        console.log(error);
        toast.error('Oops! We encountered an error. Please refresh the page and retry logging in.')

    });

    return {
        type: FETCH_CC_META_DATA_ON_VIEW_CHANGE,
        payload: req
    };
};

export const getCollectionsList = () => {
    let token = localStorage.getItem("token");
    let req = axios
        .post(`${getBaseUrl()}/collections/list?access-token=${token}`, { team: 1, own: 1, collction_type: "all" })
        .then(response => {
            return response.data.data;
        });

    return {
        type: FETCH_COLLECTIONS_LIST,
        payload: req
    };
};

export const enableResetToDefault = () => {
    return {
        type: RESET_TO_DEFAULT_ENABLED
    }
}

export const disableResetToDefault = () => {
    return {
        type: RESET_TO_DEFAULT_DISABLED
    }
}


export const postModalOpen = () => {
    return {
        type: POST_MODAL_OPEN
    }
}


export const postModalClosed = () => {
    return {
        type: POST_MODAL_CLOSED
    }
}

export const handleGlobalRefresh = loaders => {
    return {
        type: ENABLE_GLOBAL_REFRESH,
        payload: loaders
    };
}

export const handleGlobalRefreshWithDeepDive = () => {
    return {
        type: ENABLE_GLOBAL_REFRESH_WITH_DEEP_DIVE
    }
}

export const widgetLoaded = () => {
    return {
        type: WIDGET_LOADED
    }
}

export const setWidgetLoader = (val) => {
    return {
        type: SET_WIDGET_LOADERS,
        payload: val
    }
}

export const handleGlobalLoader = (status) => {
    return {
        type: TOGGLE_GLOBAL_LOADER,
        payload: status
    };
};

export const toggleEditMode = () => {
    return {
        type: TOGGLE_EDIT_MODE
    };
};

export const handleGlobalCountry = id => {
    return {
        type: HANDLE_GLOBAL_COUNTRY,
        payload: id
    };
};

export const resetGlobalCountry = () => {
    return {
        type: RESET_GLOBAL_COUNTRY,
    };
};

export const translated = language => {
    return {
        type: TRANSLATED,
        payload: language
    }
}

export const setLastLanguage = language => {
    return {
        type: SET_LAST_LANGUAGE,
        payload: language
    }
}

export const saveGlobalFilter = filters => {
    return {
        type: SAVE_GLOBAL_FILTER,
        payload: filters
    };
}

export const resetGlobalFilter = () => {
    return {
        type: RESET_GLOBAL_FILTER,
    };
}
